<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
import { IconType } from '$shared/constants/IconType';
  import Label from '$provider/constants/Label';
  import Action from './partials/Action.svelte';
  import { AlertBannerModel } from '$provider/models/alertBanner/AlertBannerModel';

  interface Props {
    loading?: boolean;
    option?: AlertBannerModel<unknown> | null;
    icon?: import('svelte').Snippet;
    oncancel?: () => void;
    onclose?: () => void;
    onbanneraction?: (payload: { actionLabel: string }) => void;
  }

  let { loading = false, option = null, icon, oncancel, onclose, onbanneraction }: Props = $props();

  const onClickCancel = (): void => {
    oncancel?.();
  };

  const onClickClose = (): void => {
    onclose?.();
  };
</script>

{#if option}
  <div class="comp-alert-banner {option.type}" data-cy="alert-banner">
    <div class="banner-content">
      <div class="left-content">
        <div class="icon">
          {#if option.bannerIcon}
            <Icon value={option.bannerIcon} fontSize="24px" size="24px" />
          {/if}
          {@render icon?.()}
        </div>
        <div class="disclaimer" data-cy="alert-banner-label">
          {@html option.label}
          {#if option.showCancel}(<button
              data-cy="cancel-merge-btn"
              onclick={onClickCancel}
              class="link-action"
            >
              {Label.Cancel}
            </button>)
          {/if}
        </div>
      </div>
      {#if option.hasAction}
        <div class="right-content">
          <Action
            actionLabel={option.actionLabel}
            actionIcon={option.actionIcon}
            {loading}
            {onbanneraction}
          />
          {#if option.closable}
            <Icon
              type={IconType.Button}
              value="icon-x"
              fontSize="18px"
              size="18px"
              onclick={onClickClose}
            />
          {/if}
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .comp-alert-banner {
    border-radius: 6px;
    box-shadow: 1px 10px 15px -10px rgba(0, 0, 0, 0.1);
    background-color: var(--light-blue);
    padding: 8px;
  }
  .comp-alert-banner.info {
    background-color: var(--light-blue);
  }
  .comp-alert-banner.warn {
    background-color: var(--yellow-light);
  }
  .comp-alert-banner.success {
    background-color: var(--green-light);
  }
  .banner-content {
    display: flex;
    justify-content: space-between;
  }
  .left-content {
    display: inline-flex;
    align-items: center;
  }
  .left-content .icon {
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
  }
  .left-content .disclaimer .link-action {
    font-weight: 400;
    color: var(--blue);
    cursor: pointer;
  }
  .right-content {
    display: inline-flex;
    align-items: center;
  }
</style>
